import { IBridgeProvidedAction } from "@vega/bridge";

export const OpenInvoiceByInvoiceUqActionId = "open-invoice-by-invoiceUq";

export class OpenInvoiceByInvoiceUqActionData {
    public invoiceUq: number | undefined;
}

export type OpenInvoiceByInvoiceUqAction = IBridgeProvidedAction<OpenInvoiceByInvoiceUqActionData, void>;
